module.exports = __webpack_public_path__ + "media/src/website/images/locations/muehldorf/muehldorf_02-4f130be0b856ecd1a503bef42b6ee1a5.jpg";